import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import cn from 'classnames';
import Checkbox from '@material-ui/core/Checkbox';
import IndeterminateCheckBox from '@material-ui/icons/IndeterminateCheckBox';

import './brMultistateCheckbox.scss';

export const CheckboxStates = {
  None: 'none',
  Partial: 'partial',
  All: 'all',
};

export default class BrMultistateCheckbox extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    state: PropTypes.oneOf(Object.values(CheckboxStates)),
    onClickCheckbox: PropTypes.func.isRequired,
    useBulkActions: PropTypes.bool,
  };

  static defaultProps = {
    state: CheckboxStates.None,
    useBulkActions: false,
  };

  handleToggleCheckbox = (e) => {
    e.stopPropagation();
    const { onClickCheckbox } = this.props;
    switch (this.props.state) {
      case CheckboxStates.None:
      case CheckboxStates.Partial:
        return onClickCheckbox(CheckboxStates.All);
      case CheckboxStates.All:
        return onClickCheckbox(CheckboxStates.None);
    }
  };

  handleToggleCheckboxV2 = (e) => {
    e.stopPropagation();
    const { onClickCheckbox } = this.props;
    switch (this.props.state) {
      case CheckboxStates.Partial:
        return onClickCheckbox(CheckboxStates.None);
      case CheckboxStates.None:
        return onClickCheckbox(CheckboxStates.Partial);
      case CheckboxStates.All:
        return onClickCheckbox(CheckboxStates.None);
    }
  };

  render() {
    const { className, state, useBulkActions } = this.props;
    const classname = cn('br-multistate-checkbox', className, {
      'indeterminate-icon': state === CheckboxStates.Partial,
      'customised-indeterminate-icon': useBulkActions,
    });

    return (
      <div
        className={classname}
        data-id="br-multistate-checkbox"
        onClick={useBulkActions ? this.handleToggleCheckboxV2 : this.handleToggleCheckbox}
      >
        {!useBulkActions ? (
          <>
            {state === CheckboxStates.None && <input type="checkbox" readOnly />}
            {state === CheckboxStates.All && <input type="checkbox" readOnly checked />}
            {state === CheckboxStates.Partial && <div className="br-checkbox-middle-state">&#8211;</div>}
          </>
        ) : (
          <>
            {state === CheckboxStates.None && <Checkbox className="custom-fill" readOnly />}
            {state === CheckboxStates.All && <Checkbox type="checkbox" checked />}
            {state === CheckboxStates.Partial && <IndeterminateCheckBox className="custom-indeterminate-icon" />}
          </>
        )}
      </div>
    );
  }
}
